const messages = {
  en: 'Product',
  'es-ud': 'Producto',
  es: 'Producto'
}

export default messages



// WEBPACK FOOTER //
// ./src/hocs/ProductNameHOC/messages.js